import { Export } from '@phosphor-icons/react';

export default Export;
